import { shouldIntegrateSessionRecording } from '@modules/common/utils';
import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';
import { shouldSendAnalyticsEvents } from 'v2/analytics/analytics';
import { User } from 'v2/core/entities/user';

export const useInitPostHogSessionRecording = (user: User | undefined) => {
  const posthog = usePostHog();

  useEffect(() => {
    if (!user?.id || !shouldSendAnalyticsEvents()) {
      return;
    }

    posthog.identify(user.id, {
      email: user.email,
    });
    posthog.group('tenant', user.tenant.name);

    if (shouldIntegrateSessionRecording(user.email)) {
      posthog.startSessionRecording();
    }
  }, [posthog, user?.email, user?.id, user?.tenant.name]);
};
